import { MapLayer } from '../../layers/mapLayer.abstract';

export class BaseLayerOption {
  constructor(
    public name: string,
    public getLayers: () => Array<MapLayer>,
  ) { }
}
